var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"margin-bottom":"45px","min-height":"800px","display":"flex","flex-wrap":"wrap","justify-content":"center"}},_vm._l((_vm.infraArray),function(card){return _c('Card',{key:card.id,staticStyle:{"margin-bottom":"4vw"},attrs:{"card":card}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }